import {useState} from 'react'

export const useForceRender = () => {
    const s = useState(0)[1];
    return () => s(Date.now());
};